
import Header from "./Header";
import Hero from "./HeroSection";
import ArchitectureSection from "./ArchitectureSection";
import PricingSection from "./PricingSection";
import RoadmapSection from "./RoadmapSection";
import GaoComparison from "./GaoComparison";
import Footer from "./Footer";
//bg-[#030712]
const WorkSpacePage = () => {
  return (
    <div className="min-h-screen   no-scrollbar overflow-y-auto ">
      {/* Background Effects - Đổi sang tone Vàng Đồng */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-[-10%] left-[-10%] w-[500px] h-[500px] bg-amber-500/10 rounded-full blur-[120px]" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[500px] h-[500px] bg-yellow-600/5 rounded-full blur-[120px]" />
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:40px_40px]" />
      </div>

     
      <Header />
      <Hero />
     <ArchitectureSection />
     <PricingSection />
     < GaoComparison />
     <RoadmapSection />
     <Footer />
    </div>
  );
};

export default WorkSpacePage;